import { render, staticRenderFns } from "./input1bienvenido.vue?vue&type=template&id=fb622886"
import script from "./input1bienvenido.vue?vue&type=script&lang=js"
export * from "./input1bienvenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports